import { render, staticRenderFns } from "./FriendlyRecaptcha.vue?vue&type=template&id=82d9bed2&scoped=true"
import script from "./FriendlyRecaptcha.vue?vue&type=script&lang=js"
export * from "./FriendlyRecaptcha.vue?vue&type=script&lang=js"
import style0 from "./FriendlyRecaptcha.vue?vue&type=style&index=0&id=82d9bed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d9bed2",
  null
  
)

export default component.exports